//环境更改、构建配置
//1、test环境   2、uat环境    3、prd环境

// npm run dev 运行开发模式
// npm run test 构建测试环境
// npm run uat 构建uat环境
// npm run prd 构建生产环境

const typeEnum = {
  serve: 1,
  dev: 1,
  test: 1,
  uat: 2,
  sim:4,
  prd: 3
};
let env_type = typeEnum[process.env.VUE_APP_TYPE] || 3;

//手动修改接口配置(生产环境无效)
// env_type = 1;
// env_type = process.env.VUE_APP_TYPE == 'prd' ? 3 : 2;

module.exports = {
  env_type
};